<template>
  <el-drawer
    :title="titleDrawer"
    :visible.sync="drawerAmonestacionOrigen"
    :before-close="closeDrawerAmonestacion"
    @closed="closeDrawerAmonestacion"
    size="55%"
  >
    <div id="amonestacion-pdf-content">
      <el-container direction="vertical">
        <el-main>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form
                ref="form"
                label-position="left"
                size="mini"
                label-width="200px"
                :model="model"
              >
                <el-form-item v-if="isView">
                  <div style="margin-left: 150px">
                    <img
                      src="../../../../../../../src/assets/images/logocortado.png"
                      style="width: 150px"
                    />
                  </div>
                  <div style="margin-left: 170px">
                    <h4>Tennos Business</h4>
                  </div>
                  <div style="margin-left: 165px">
                    <h4>RNC: 131844804</h4>
                  </div>
                  <div style="margin-left: 155px">
                    <h4>RNL: 1318448040001</h4>
                  </div>
                </el-form-item>
                <el-form-item label="Titulo">
                  <el-input v-model="model.Title"></el-input>
                </el-form-item>
                <el-form-item label="Fecha">
                  <el-date-picker
                    v-model="model.WarningDate"
                    type="datetime"
                    placeholder="Fecha"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="Descripcion">
                  <quillEditor v-model="model.Description"></quillEditor>
                </el-form-item>

                <el-form-item label="Tipo">
                  <div class="box">
                    <el-select
                      v-model="model.Type"
                      clearable
                      placeholder="Tipo"
                      @change="handleChangeType"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>

                <el-form-item
                  label="Articulo 88"
                  v-if="isView && dataArt88.length != 0"
                >
                  <el-table
                    ref="multipleTable"
                    :data="dataArt88"
                    @selection-change="handleSelectionChangeFirstTable"
                  >
                    <el-table-column
                      property="IdOrd"
                      label="Ordenal"
                      width="90"
                    >
                    </el-table-column>
                    <el-table-column
                      property="Descri"
                      label="Descripcion"
                      width="400"
                    >
                      <!-- <template slot-scope="scope">
                      <el-popover
                        placement="top-start"
                        width="480"
                        trigger="hover"
                        :content="scope.row.Descri"
                      >
                        <el-button slot="reference">{{
                          scope.row.Descri
                        }}</el-button>
                      </el-popover>
                    </template> -->
                    </el-table-column>
                  </el-table>
                </el-form-item>

                <el-form-item
                  label="Articulo 88"
                  v-if="!isView && model.Type == 1"
                >
                  <el-collapse>
                    <el-collapse-item name="1">
                      <el-table
                        ref="multipleTable"
                        :data="dataArt88"
                        @selection-change="handleSelectionChangeFirstTable"
                      >
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column
                          property="IdArt"
                          label="Articulo"
                          width="120"
                        >
                        </el-table-column>
                        <el-table-column
                          property="IdOrd"
                          label="Ordenal"
                          width="120"
                        >
                        </el-table-column>
                        <el-table-column label="Descripcion">
                          <template slot-scope="scope">
                            <!-- Contenido del popover -->
                            <el-popover
                              placement="top-start"
                              width="480"
                              trigger="hover"
                              :content="scope.row.Descri"
                            >
                              <!-- Botón de referencia que activa el popover -->
                              <el-button slot="reference">{{
                                scope.row.Descri
                              }}</el-button>
                            </el-popover>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-collapse-item>
                  </el-collapse>
                </el-form-item>

                <el-form-item
                  label="Articulo 45"
                  v-if="isView && dataArt45.length != 0"
                >
                  <el-table
                    ref="multipleTable"
                    :data="dataArt45"
                    @selection-change="handleSelectionChangeSecondTable"
                  >
                    <el-table-column
                      property="IdOrd"
                      label="Ordenal"
                      width="90"
                    >
                    </el-table-column>
                    <el-table-column
                      label="Descripcion"
                      property="Descri"
                      width="400"
                    >
                      <!-- <template slot-scope="scope">
                      <el-popover
                        placement="top-start"
                        width="480"
                        trigger="hover"
                        :content="scope.row.Descri"
                      >
                        <el-button slot="reference">{{
                          scope.row.Descri
                        }}</el-button>
                      </el-popover>
                    </template> -->
                    </el-table-column>
                  </el-table>
                </el-form-item>

                <el-form-item
                  label="Articulo 45"
                  v-if="!isView && model.Type == 1"
                >
                  <el-collapse>
                    <el-collapse-item name="1">
                      <el-table
                        ref="multipleTable"
                        :data="dataArt45"
                        @selection-change="handleSelectionChangeSecondTable"
                      >
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column
                          property="IdArt"
                          label="Articulo"
                          width="120"
                        >
                        </el-table-column>
                        <el-table-column
                          property="IdOrd"
                          label="Ordenal"
                          width="120"
                        >
                        </el-table-column>
                        <el-table-column label="Descripcion">
                          <template slot-scope="scope">
                            <!-- Contenido del popover -->
                            <el-popover
                              placement="top-start"
                              width="480"
                              trigger="hover"
                              :content="scope.row.Descri"
                            >
                              <!-- Botón de referencia que activa el popover -->
                              <el-button slot="reference">{{
                                scope.row.Descri
                              }}</el-button>
                            </el-popover>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-collapse-item>
                  </el-collapse>
                </el-form-item>

                <el-form-item
                  label="Articulo 44"
                  v-if="isView && dataArt44.length != 0"
                >
                  <el-table
                    ref="multipleTable"
                    :data="dataArt44"
                    @selection-change="handleSelectionChangeSecondTable"
                  >
                    <el-table-column
                      property="IdOrd"
                      label="Ordenal"
                      width="90"
                    >
                    </el-table-column>
                    <el-table-column
                      label="Descripcion"
                      property="Descri"
                      width="400"
                    >
                      <!-- <template slot-scope="scope">
                      <el-popover
                        placement="top-start"
                        width="480"
                        trigger="hover"
                        :content="scope.row.Descri"
                      >
                        <el-button slot="reference">{{
                          scope.row.Descri
                        }}</el-button>
                      </el-popover>
                    </template> -->
                    </el-table-column>
                  </el-table>
                </el-form-item>

                <el-form-item
                  label="Articulo 44"
                  v-if="!isView && model.Type == 2"
                >
                  <el-collapse>
                    <el-collapse-item name="1">
                      <el-table
                        ref="multipleTable"
                        :data="dataArt44"
                        @selection-change="handleSelectionChangeSecondTable"
                      >
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column
                          property="IdArt"
                          label="Articulo"
                          width="120"
                        >
                        </el-table-column>
                        <el-table-column
                          property="IdOrd"
                          label="Ordenal"
                          width="120"
                        >
                        </el-table-column>
                        <el-table-column label="Descripcion">
                          <template slot-scope="scope">
                            <!-- Contenido del popover -->
                            <el-popover
                              placement="top-start"
                              width="480"
                              trigger="hover"
                              :content="scope.row.Descri"
                            >
                              <!-- Botón de referencia que activa el popover -->
                              <el-button slot="reference">{{
                                scope.row.Descri
                              }}</el-button>
                            </el-popover>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-collapse-item>
                  </el-collapse>
                </el-form-item>

                <el-form-item label="Colaborador" v-if="!isView">
                  <employee-selector
                    v-model="model.ReprimandedEmployee"
                    :CurrentEmployee="model.ReprimandedEmployee"
                    @selection-change="SelectedEmployee"
                  ></employee-selector>
                </el-form-item>

                <!-- <el-form-item
                  label="Acuerdo"
                  v-if="isView && model.Type == 'Llamado Atencion'"
                >
                  <el-input
                    type="textarea"
                    autosize
                    placeholder="Please input"
                    v-model="Commentary"
                  >
                  </el-input>
                </el-form-item> -->

                <el-form-item
                  label="Acuerdo"
                  v-if="isView && model.Type == 'Llamado Atencion'"
                >
                  <quillEditor v-model="Commentary"></quillEditor>
                </el-form-item>

                <el-form-item v-if="isView">
                  <el-row :gutter="20">
                    <el-col :span="6"
                      ><div style="width: 150px; color: black">
                        <h4>---------------------</h4>
                        <h4>Amonestado</h4>
                        <employee-selector
                          v-model="model.ReprimandedEmployee"
                          :CurrentEmployee="model.ReprimandedEmployee"
                          @selection-change="SelectedEmployee"
                        ></employee-selector></div
                    ></el-col>
                    <el-col :span="6"
                      ><div style="width: 150px; color: black">
                        <h4>---------------------</h4>
                        <h4>Amonestador</h4>
                        <employee-selector
                          v-model="model.IdEmployee"
                          :CurrentEmployee="model.IdEmployee"
                          @selection-change="SelectedEmployee2"
                        ></employee-selector></div
                    ></el-col>
                    <el-col :span="6">
                      <div style="width: 150px; color: black">
                        <h4>---------------------</h4>
                        <h4>Recursos Humanos</h4>
                        <employee-selector
                          v-model="RRHHId"
                          :CurrentEmployee="RRHHId"
                          @selection-change="SelectedEmployee2"
                        ></employee-selector>
                      </div>
                    </el-col>
                    <el-col :span="6"
                      ><div class="grid-content bg-purple"></div
                    ></el-col>
                  </el-row>
                </el-form-item>
                <el-form-item v-if="isView">
                  <h4>Cc. Ministerio de Trabajo</h4>
                </el-form-item>

                <!-- <el-form-item label="Cedula" v-if="isView">
                <el-input
                  v-model="CardReprimanded"
                  size="small"
                  style="width: 200px"
                ></el-input>
              </el-form-item> -->

                <!-- <el-form-item label="Amonestador" v-if="isView">
                <employee-selector
                  v-model="model.IdEmployee"
                  :CurrentEmployee="model.IdEmployee"
                  @selection-change="SelectedEmployee2"
                ></employee-selector>
              </el-form-item> -->

                <el-form-item v-if="!isView">
                  <UploadFileEvidence ref="UploadFile"></UploadFileEvidence>
                </el-form-item>

                <el-form-item v-if="this.model.Evidence" label="Archivo">
                  <el-button
                    type="primary"
                    icon="el-icon-document"
                    size="mini"
                    v-on:click="openFile(null)"
                    >Ver Evidencia</el-button
                  >
                </el-form-item>
                <br />
                <el-form-item>
                  <el-button
                    v-if="!isView"
                    type="primary"
                    :loading="autoLoading"
                    @click="
                      model.Evidence === '' || model.Evidence === null
                        ? uploadFile()
                        : CreateRequestVacation()
                    "
                    :disabled="isView || autoLoading"
                    >Registrar</el-button
                  >
                  <el-button
                    v-if="isView"
                    type="primary"
                    :loading="autoLoading"
                    @click="printToPDF()"
                    :disabled="autoLoading"
                    >Imprimir PDF</el-button
                  >
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </div>
  </el-drawer>
</template>
<script>
import EmployeeSelector from "@/components/Company/EmployeeSelector.vue";
import UploadFileEvidence from "@/views/apps/employees/RRHH/Modules/Amonestacion/uploadEvidente.vue";
import html2pdf from "html2pdf.js";
import { quillEditor } from "vue-quill-editor";
//import tennosLogoVacano from "../../../../../../../src/assets/images/logocortado.png"

export default {
  name: "DrawerAmonestacion",
  components: {
    EmployeeSelector,
    UploadFileEvidence,
    quillEditor
  },
  props: {
    drawerAmonestacionOrigen: {
      type: Boolean,
      default: false
    },

    isCreatedProp: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      //SUBIDA ARCHIVOS
      fileList: [],
      filesUpload: 0,
      data: [],
      dataItem: [],
      titleDrawer: "Registro Amonestacion/Llamado Atencion",
      autoLoading: false,
      isCreated: false,
      isView: false,
      dataArt88: [],
      dataArt45: [],
      dataArt44: [],
      CardReprimanded: "",

      //SELECT TIPO
      options: [
        {
          value: "1",
          label: "Amonestacion"
        },
        {
          value: "2",
          label: "Llamados Atencion"
        }
      ],
      value: "",
      model: {
        IdEmployee: null,
        ReprimandedEmployee: null,
        WarningDate: "",
        Type: "1",
        Description: "",
        Evidence: "",
        ItemWarning: [],
        Title: ""
      },

      RRHHId: 0,
      Commentary: ""
    };
  },

  watch: {
    isCreatedProp: {
      handler() {
        this.pruebarandom();
      },
      inmediate: true
    }
  },

  methods: {
    async printToPDF() {
      this.autoLoading = true;
      await this.$nextTick();

      const element = await document.getElementById("amonestacion-pdf-content"); // ID del elemento que deseas imprimir

      const options = {
        margin: 0,
        filename: "myfile.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] }
      };
      await html2pdf().set(options).from(element).save("Amonestacion.pdf");
      this.autoLoading = false;
    },
    handleSelectionChangeFirstTable(val) {
      const uniqueValues = new Set([...this.model.ItemWarning, ...val]);
      this.model.ItemWarning = Array.from(uniqueValues);
    },

    handleSelectionChangeSecondTable(val) {
      const uniqueValues = new Set([...this.model.ItemWarning, ...val]);
      this.model.ItemWarning = Array.from(uniqueValues);
    },

    handleChangeType(type) {
      this.model.Type = type;
    },

    SelectedEmployee(val) {
      this.model.ReprimandedEmployee = val;
    },

    closeDrawerAmonestacion() {
      this.$emit("dialog-closed");
      this.clear();
      this.drawerAmonestacionOrigen = false;
    },

    async uploadFile() {
      await this.$refs.UploadFile.submitUpload(this);
    },

    CreateRequestVacation() {
      const requestData = {
        Title: this.model.Title,
        IdEmployee: this.currentUser.EmployeeId,
        ReprimandedEmployee: this.model.ReprimandedEmployee,
        WarningDate: this.model.WarningDate,
        Type: this.model.Type,
        Description: this.model.Description,
        Evidence: this.model.Evidence,
        ItemWarning: this.model.ItemWarning
      };

      this.$http
        .post("/api/Modules/AddWarning", requestData)
        .then((resp) => {
          this.data = resp.data;
        })
        .catch((error) => {
          this.$message.error("Error al cargar detalles", error);
        })
        .finally(() => {
          this.autoLoading = false;
          this.$emit("refreshTable");
          this.clear();
          this.closeDrawerAmonestacion();
        });
    },
    pruebarandom() {
      this.$http.get("/api/Modules/GetListArt88").then((resp) => {
        this.dataArt88 = resp.data.filter((element) => {
          return element.IdArt === 88;
        });
        this.dataArt45 = resp.data.filter((element) => {
          return element.IdArt === 45;
        });
        this.dataArt44 = resp.data.filter((element) => {
          return element.IdArt === 44;
        });
      });
    },

    show(data = {}, isView = false, isCreated = false) {
      if (isCreated) {
        this.isView = false;
        this.titleDrawer = "Solicitud de Amonestacion";
        this.data = data;
      }
      if (isView) {
        (this.titleDrawer = "Informacion Sobre Amonestacion"),
          (this.isCreated = false),
          (this.model = {
            ...this.model,
            ...data.task
          });
        this.isView = isView;
        this.data = data.task.row;
        this.model.IdEmployee = data.rowforminfo.IdEmployee;
        this.CardReprimanded = data.rowforminfo.CardReprimanded;
        this.RRHHId = data.rowforminfo.RRHHId;
        this.Commentary = data.rowforminfo.Commentary;
        this.model.Title = data.rowforminfo.Title;
        //this.model.ReprimandedEmployee = data.task.ReprimandedEmployee;
        this.dataArt88 = data.articless.filter((element) => {
          return element.IdArt === 88;
        });
        this.dataArt45 = data.articless.filter((element) => {
          return element.IdArt === 45;
        });
        this.dataArt44 = data.articless.filter((element) => {
          return element.IdArt === 44;
        });
      }
      this.drawerAmonestacionOrigen = true;
    },

    clear() {
      this.model = {
        ReprimandedEmployee: "",
        WarningDate: "",
        Type: 0,
        Description: "",
        ItemWarning: [],
        Title: ""
      };
    },

    getUpdatedData() {
      this.$emit("update-data");
    },

    handleExceed(files) {
      this.$message.warning(
        `El límite es 1, haz seleccionado ${
          files.length
        } archivos esta vez, añade hasta ${files.length + 0}`
      );
    },
    handleChange() {
      this.filesUpload = 1;
    },
    handleRemove() {
      this.filesUpload = 0;
    },

    openFile(url = null) {
      //console.log("url: ", url)
      if (url !== null) {
        window.open(url, "_blank");
      } else {
        window.open(this.model.Evidence, "_blank");
      }
    }
  }
};
</script>
